<template>
	<div class="heads">
		<div class="big-center">
			<div class="center">
				<el-row :gutter="20">
					<el-col :span="8">
						<div class="top-left">
							<div class="logoname">欢迎进入省钱兄自营商城</div>
							<div class="logins">
								<span v-if="!token" @click="goAbute('/login')">登录</span>
								<span v-if="!token" class="xian">|</span>
								<span v-if="!token" @click="goAbute('/login?navgatorIndex=3')">免费注册</span>
								<span v-if="token">{{userName}}</span>
								<span v-if="token" @click="quit()">退出登录</span>
							</div>
						</div>
					</el-col>
					<el-col :span="5"><div class="kong"></div></el-col>
					<el-col :span="11">
						<div class="top-right">
							<span @click="goHome()">首页</span>
							<span @click="goShoppingCar('/order')">个人中心</span>
							<span>
								<span @click="goChat()" class="el-dropdown-link" style="color: #999;">
									联系客服
								</span>
							</span>
						<!-- 	<span >
								<el-dropdown  @command="handleCommand">
									<span class="el-dropdown-link" style="color: #999;">
										网站导航<i class="el-icon-arrow-down el-icon--right"></i>
									</span>
									<el-dropdown-menu slot="dropdown">
										<div style="width: 200px;display: inline-block;">
											<el-dropdown-item v-for="(item,index) in list" :key="index" :command="item.url" >{{item.name}}</el-dropdown-item>
										</div>
									</el-dropdown-menu>
								</el-dropdown>
							</span> -->
							<span >
								<el-dropdown>
									<span class="el-dropdown-link" style="color: #999;">
										手机版<i class="el-icon-arrow-down el-icon--right"></i>
									</span>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item>
											<img style="height: 100px;width: 100px;" :src="downcode" />
										</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
							</span>
						</div>
					</el-col>
				</el-row>
			</div>
		</div>
		<div class="big-centers">
			<div class="center">
				<div class="cons left" @click="goHome()" >
					<img src="../assets/head/logo.png" />
				</div>
				<div class="cons cont">
					<div class="searchs" >
						<el-input placeholder="请输入内容" v-model="value" class="input-with-select">
							<el-button slot="append" icon="el-icon-search" @click="sousuo()">搜索</el-button>
						</el-input>
					</div>
					<div class="search-list">
						<div v-for="(item,index) in data" :key="index" :class="index<=2?'one':'four'"
							 @click="goAbute('/productList?title=' + item)">
							<span v-if="index==0" class="re bao">爆</span>
							<span v-if="index==1||index==2" class="re">热</span>
							{{item}}
						</div>
					</div>
				</div>
				<div class="cons right">
					<div class="myCars">
						<el-badge v-if="dataC" :value="dataC.length" class="item">
							<img class="carimg" src="../assets/head/card.png" />
							<span class="myCar" @click="goShoppingCar('/shoppingCar')">我的购物车</span>
						</el-badge>
						<div v-else>
							<img class="carimg" src="../assets/head/card.png" />
							<span class="myCar" @click="goShoppingCar('/shoppingCar')">我的购物车</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Head',
	props: {
		data: [],
		dataC:[]
	},
	data () {
		return {
			value: '',
			// userId:'',
			list:[
				{ name:'热卖榜单', url:'/?index=1' },
				{ name:'精选好物', url:'/?index=2' },
				{ name:'每日上线', url:'/?index=3' },
				{ name:'拼团购', url:'/?index=4' },
				// { name:'个人中心', url:'/order' },
			],
			downcode:'../assets/foot/app.png',
			userName:'',
		}
	},
	mounted() {
		// console.log(this.$cookie.get('userId'))

	},
	created() {
		this.getCode()
		if(this.token){
			this.getUserInfo()
		}
	},
	computed: {
		userId() {
			// return this.$store.state.userId
			return this.$cookie.get('userId')
		},
		token(){
			return this.$cookie.get('token')
		},
		// userName(){
		// 	return this.$cookie.get('userName')
		// }

	},
	methods:{
		//获取用户信息
		getUserInfo() {
			let that = this
			this.$http({
				url: this.$http.adornUrl3('api/index/index/my_index'),
				method: 'post',
				params: this.$http.adornParams({})
			}).then(({
				data
			}) => {
				if (data.code == 1) {
					that.userName = data.data.user_info.nickname
					that.$cookie.set('userName', data.data.user_info.nickname)
					that.$cookie.set('phone', data.data.user_info.mobile)
					that.$cookie.set('gender', data.data.user_info.gender)
					that.$cookie.set('avatar', data.data.user_info.avatar)
				}
			})
		},
		goShoppingCar(url) {
			if(this.token){
				if(this.$route.path == url) {

				} else {
					this.$router.push({
						path: url
					})
				}
			}else{
				this.$router.push({
					path: '/login'
				})
			}
		},
		goHome() {
			if(this.$route.path == '/') {

			} else {
				this.$router.push({
					path: '/'
				})
			}

		},
		goAbute(url){
			this.$router.push({
				path: url
			})
		},
		goChat() {
			if(this.token) {
				this.$router.push({
					path: '/vueMchat'
				})
			} else {
				this.$router.push({
					path: '/login'
				})
			}
		},
		handleCommand(command) {
			this.$router.push({
				path: command
			})
		},
		sousuo(){
			if(this.value==''){
				this.$message('搜索内容不能为空')
			}else{
				this.$router.push({
					path: '/productList?searchValue='+this.value+'&gotoType=1'
				})

			}
		},
		//退出登录
		quit() {
			this.$cookie.set('token', '')
			this.$cookie.set('userName', '')
			console.log(this.$route.path,'当前页路由')
			if(this.$route.path == '/') {
				this.$router.go(0)
			} else {
				this.$router.push({
					path: '/'
				})
			}

		},
		getCode() {
			this.$http({
				url: this.$http.adornUrl3('api/index/pcapi/index_footer'), //app下载地址
				method: 'post',
			}).then(({data}) => {
				window.localStorage.setItem("downcode",data.data.pc_appqrcode);
				this.downcode = data.data.pc_appqrcode
			})

		}

	}
}
</script>
<style scoped="scoped">
.big-center{
	width: 100%;
	height: 24px;
	line-height: 24px;
	color: #999;
	font-size: 14px;
	background: #E6E6E6;
}
.center{
	width: 1200px;
	margin: 0 auto;
}
.top-left{
	text-align: left;

}
.top-left div{
	display: inline-block;
}
.logoname{
	width: 40%;
}
.logins{
	width: 50%;
	text-align: center;
}
.logins span{
	color: #999;
	text-decoration:none;
}
.logins span:hover{
	color: #FF0D18;
	cursor: pointer;
}
.xian{
	margin: 0 10px;
}
.kong{
	width: 100%;
	height: 24px;
}
.top-right{
	text-align: right;
}
.top-right span{
	display: inline-block;
	margin-left: 20px;
	color: #999;
	text-decoration:none;
}
.top-right span:hover{
	color: #FF0D18;
	cursor: pointer;
}
.big-centers{
	width: 100%;
	height: 120px;
	/* line-height: 120px; */
}
.big-centers .center .cons{
	display: inline-block;
}
.left{
	width: 30%;
	text-align: left;
}
.left img{
	position: relative;
	bottom: 6px;
}

.cont{
	width: 49%;

}
.searchs{
	padding-top: 26px;
}

.search-list{
	text-align: left;
	font-size: 14px;
	color: #999;
	margin-top: 10px;
}
.search-list div{
	display: inline-block;
	width: 16%;
	cursor: pointer;
}
.one{
	color: #FF0D18;
}
.one .re{
	display: inline-block;
	font-size: 12px;
	border: 1px solid #E1251B;
	/* width: 14px;
    height: 14px; */
	border-radius: 2px;
	background: #FFC1C1;
	padding: 0 2px;
	/* margin-right: 6px; */
}

.right{
	width: 20%;
	text-align: right;
	color: #E1251B;
	font-size: 18px;
}
.myCars{
	position: relative;
	bottom: 20px;
	border: 2px solid #E1251B;
	border-radius: 4px;
	width: 65%;
	text-align: center;
	height: 45px;
	line-height: 45px;
	margin-left: 35%;
	cursor: pointer;
}
.carimg{
	position: relative;
	top: 3px;
}

.el-input-group__append, .el-input-group__prepend{
	background: #E1251B!important;
	color: #fff!important;
	border: 1px solid #FF2D55!important;
}
</style>



// WEBPACK FOOTER //
// src/components/head.vue